export interface DisplayItem {
    id: number;
    title?: string;
    display_text: string;
    type: string;
    media_url?: string;
    icon_id?: number;
    activetimestamp: string;
    generate_attention: boolean;
}

export class DICONSTS {
    public static readonly DI_TYPE_CHUNK = 'chunk';
    public static readonly DI_TYPE_PARTITION = 'partition';
    public static readonly DI_TYPE_INSTANT = 'instant';
}
